import { create } from "zustand";
import { persist } from "zustand/middleware";

interface User {
  id: number;
  authenticated: boolean;
  username: string;
  user_image: string;
}

interface AuthState {
  token: string | null;
  isAuthenticated: boolean;
  user: User | null;
  setIsAuthenticated: (isAuthenticated: boolean) => void;
  setToken: (token: string | null) => void;
  setUser: (user: User | null) => void;
  setLogout: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      token: null,
      isAuthenticated: false,
      user: null,
      setToken: (token) => set({ token }),
      setIsAuthenticated: (isAuthenticated) => set({ isAuthenticated }),
      setUser: (user) => set({ user }),
      setLogout: () => set({ token: null, isAuthenticated: false, user: null }),
    }),
    {
      name: "auth-storage",
    }
  )
);
